import { render, staticRenderFns } from "./StockCollectionForm.vue?vue&type=template&id=616fedb8"
import script from "./StockCollectionForm.vue?vue&type=script&lang=js"
export * from "./StockCollectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports